import { io, Socket } from 'socket.io-client';

/**
 * Singleton Socket.io client. The browser inherits the cookie-based
 * session, so we don't pass a manual token in dev; in cross-origin
 * setups the caller can call `setAuthToken()` before `connect()`.
 *
 * Reconnects forever — PlyEZ's bell is best-effort, and a missed
 * `notification:new` is recoverable via the unread-count polling that
 * useNotifications does as a safety net.
 */
let socket: Socket | null = null;
let authToken: string | null = null;

export function setAuthToken(token: string | null): void {
  authToken = token;
  if (socket) {
    socket.auth = { token: token ?? undefined };
    socket.disconnect().connect();
  }
}

export function getSocket(): Socket {
  if (!socket) {
    socket = io({
      // Defaults to window.location.origin, so dev (Vite proxy) and prod
      // (nginx same-origin) both work without configuration.
      withCredentials: true,
      autoConnect: true,
      reconnection: true,
      auth: { token: authToken ?? undefined },
    });
  }
  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
